(function() {
	var radioGroup = document.querySelector('.tora-page__form .form-group-2');
	var radioButton = document.querySelector('.tora-page__form input#t-Average');
	var startDateInput = document.querySelector('.tora-page__form .form-input-group--tora-startdate');
	var checkboxGroup = document.querySelector('.tora-page__form .checkbox-group');

	function toggleSearchOptions() {
		if (radioButton.checked) {
			checkboxGroup.classList.remove('hide');
			startDateInput.classList.remove('hide');
		} else {
			checkboxGroup.classList.add('hide');
			startDateInput.classList.add('hide');
		}
	}

	if (radioButton) {
		toggleSearchOptions();

		radioGroup.addEventListener('change', function () {
			toggleSearchOptions();
		});
	}
})();
